var _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSplitIconSmall = function SvgSplitIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 18.001,
    viewBox: "0 0 32.002 18.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M698.589,392.813h-31v-17h31Z",
    transform: "translate(-667.088 -375.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M668.088,376.312v16h30v-16h-30m-1-1h32v18h-32Z",
    transform: "translate(-667.088 -375.312)",
    fill: "#024"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M669.087,377.311h21.092v14H669.087Z",
    transform: "translate(-667.088 -375.312)",
    fill: "#024"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-2",
    "data-name": "Grey Box-2",
    d: "M691.088,382.311h6v4h-6Z",
    transform: "translate(-667.088 -375.312)",
    fill: "#024"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSplitIconSmall);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNTIiIGRhdGEtbmFtZT0iR3JvdXAgNTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyLjAwMiIgaGVpZ2h0PSIxOC4wMDEiIHZpZXdCb3g9IjAgMCAzMi4wMDIgMTguMDAxIj4KICA8ZyBpZD0iV2hpdGVfQm94IiBkYXRhLW5hbWU9IldoaXRlIEJveCI+CiAgICA8cGF0aCBpZD0iUGF0aF8xIiBkYXRhLW5hbWU9IlBhdGggMSIgZD0iTTY5OC41ODksMzkyLjgxM2gtMzF2LTE3aDMxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2Ny4wODggLTM3NS4zMTIpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yIiBkYXRhLW5hbWU9IlBhdGggMiIgZD0iTTY2OC4wODgsMzc2LjMxMnYxNmgzMHYtMTZoLTMwbS0xLTFoMzJ2MThoLTMyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2Ny4wODggLTM3NS4zMTIpIiBmaWxsPSIjMDI0Ii8+CiAgPC9nPgogIDxwYXRoIGlkPSJHcmV5X0JveCIgZGF0YS1uYW1lPSJHcmV5IEJveCIgZD0iTTY2OS4wODcsMzc3LjMxMWgyMS4wOTJ2MTRINjY5LjA4N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NjcuMDg4IC0zNzUuMzEyKSIgZmlsbD0iIzAyNCIvPgogIDxnIGlkPSJHcm91cF8xNTMiIGRhdGEtbmFtZT0iR3JvdXAgMTUzIj4KICAgIDxwYXRoIGlkPSJHcmV5X0JveC0yIiBkYXRhLW5hbWU9IkdyZXkgQm94LTIiIGQ9Ik02OTEuMDg4LDM4Mi4zMTFoNnY0aC02WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2Ny4wODggLTM3NS4zMTIpIiBmaWxsPSIjMDI0Ii8+CiAgPC9nPgo8L3N2Zz4K";